import { APPOINTMENT_STATUS_DATA } from '../actions/actionType'

const initialState = {
  statuses: [],
}
export default function AppointmentStatusReducer(state = initialState, action) {
  switch (action.type) {
    case APPOINTMENT_STATUS_DATA:
      return { ...state, statuses: action.payload }
    default:
      return state
  }
}
